import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { VehicleAvatar } from '../../../../components/VehicleAvatar';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { performAction } from '../../actions';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { Cell } from '../Cell';
import { PerformActionButton } from '../PerformActionButton';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { Well } from '../../../../components/Well';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { VBox } from '../../../../components/Box';
import { VehiclePropertyEditableInput } from '../../../Vehicles/components/VehiclePropertyEditableInput';
import { setVehicleProperty } from '../../../Vehicles/actions';
import { VehiclePropertyLoadable } from '../../../Vehicles/components/VehiclePropertyLoadable';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import styles from './WS_Default.module.css';

import { KanbanVehicleRemarks } from '../../components/KanbanVehicleRemarks';
import { getRemarkType } from '../helpers/getRemarkType';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { selectUserId, selectWork, selectWorks } from '../../../Api/selectors';
import { selectVehicle } from '../../../Vehicles/selectors';

const Container = styled.div`
  .formField {
    width: 100%;
    .form-controlField {
      > div {
        width: 100%;
      }
    }
  }
`;

const STATE = {
  approve: false,
  regplate_code: '',
};

const TASK_REMARK_TYPE = 'Labels';

/* eslint-disable react/prefer-stateless-function */
class WS1_1_LabelsComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    if (this.props.vehicleDetails) {
      this.props.onClose();
    }
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  renderApprove() {
    if (!this.state.approve && !this.props.vehicleDetails) return null;

    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.props.action.label}>
        <WithVehicle vehicle_id={this.vehicle.id}>
          <VehicleHeader vehicle={this.vehicle} />

          <h3 style={{ color: 'red' }}>{this.vehicle.task_AVN ? 'AVN voertuig' : ''}</h3>

          <VBox gap="8px" padding="0 0 8px">
            <div className={styles.editableInputContainer}>
              <VehiclePropertyEditableInput
                classNameInput={styles.editableInput}
                className={styles.editableInputButton}
                propertyName="mileage"
                vehicle_id={this.vehicle.id}
              />
            </div>
            <div className={styles.editableInputContainer}>
              <VehiclePropertyEditableInput
                classNameInput={styles.editableInput}
                className={styles.editableInputButton}
                propertyName="vin"
                vehicle_id={this.vehicle.id}
              />
            </div>
            <VehiclePropertyEditableInput propertyName="num_keys" vehicle_id={this.vehicle.id} className={styles.numKeys} />
          </VBox>
          <br />
          <VehiclePropertyLoadable className="text-center" name="label_printer_queue">
            <ButtonComponent style={'ButtonSoftEditFullWidth'} onClick={this.props.print}>
              Print
            </ButtonComponent>
          </VehiclePropertyLoadable>

          <div className="d-flex gap-2 mt-3">
            <PerformActionButton
              className={styles.confirmButton}
              action={this.props.action}
              target={this.vehicle}
              onChange={this.reset.bind(this)}
            />
            <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
              {this.lbl('cancel')}
            </ButtonComponent>
          </div>
        </WithVehicle>
      </ModalComponent>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <Cell className={styles.cell}>
        <Container>
          <VehicleHeader vehicle={vehicle} />

          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                {this.props.workRemarks ? (
                  <Loader small />
                ) : (
                  <KanbanVehicleRemarks
                    readOnly
                    taskName={TASK_REMARK_TYPE}
                    kanbanBoardLabel={this.props.board?.label}
                    vehicleId={this.vehicle.id}
                    loggedUserId={this.props.loggedInUserId}
                  />
                )}
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle.regplate_code || '' })}
                >
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

WS1_1_LabelsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`]),
    loggedInUserId: selectUserId(),
    workRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-${getRemarkType(TASK_REMARK_TYPE)}`),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm(vehicle_id, regplate_code) {
      dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    },
    setProperty(name, value) {
      dispatch(setVehicleProperty(ownProps.cell.vehicle.id, name, value));
    },
    print() {
      dispatch(setVehicleProperty(ownProps.cell.vehicle.id, 'label_printer_queue', '1'));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WS1_1_Labels = compose(withConnect, withRouter)(WS1_1_LabelsComp);
